export default __webpack_public_path__ + "static/media/anime.7be32d4e.png";